import { Button } from '@almbrand/button';
import { Modal } from '@almbrand/modal';
import { Paragraph } from '@almbrand/paragraph';
import { BasketThemeName } from '../Basket.types';
import styles from './DeleteProductConfirmationModal.module.scss';

export interface DeleteProductConfirmationModalProps {
	themeName?: BasketThemeName;
	onConfirm: () => void;
	onCancel: () => void;
	text: {
		title: string;
		description: string;
		confirmBtnLabel: string;
	};
}

export type DeleteProductConfirmationModalText = DeleteProductConfirmationModalProps['text'];

export const DeleteProductConfirmationModal: React.FC<DeleteProductConfirmationModalProps> = ({
	onConfirm,
	onCancel,
	text: { title, description, confirmBtnLabel },
}) => (
	<Modal
		title={title}
		handleClose={onCancel}
		mode='default'
		mobileVariation='default'
		role='dialog'
	>
		<div className={styles.DeleteProductConfirmationModal__content}>
			<Paragraph
				text={description}
				paragraphType={{ kind: 'paragraph', size: 'default' }}
				fontColor='primaryDark'
			/>
			<div className={styles.DeleteProductConfirmationModal__actions}>
				<Button
					buttonType='primary'
					onClick={onConfirm}
					className={styles.DeleteProductConfirmationModal__confirmBtn}
				>
					{confirmBtnLabel}
				</Button>
			</div>
		</div>
	</Modal>
);
